import React, {Component} from 'react';
import {Label} from 'semantic-ui-react';

class SaleState extends Component {
    render(){
        let text = this.props.state === 1 ? 'Pendiente' : this.props.state === 2 ? 'Anulada' : 'Pagada';
        let color = this.props.state === 1 ? 'orange' : this.props.state === 2 ? 'blue' : 'green';

        return(
            <span>
                <Label color={color}>{text}</Label>
            </span>
        )
    }
}
export default SaleState;


// WEBPACK FOOTER //
// ./src/components/sales/SaleState.js